import { AvailabilityHoursFormConfig, getAvailabilityHoursFormFields } from '@frontend/schedule-availability-hours';
import { isValidHTTPUrl } from '@frontend/uri';
import { FormConfig } from '@frontend/design-system';
import { MAX_LENGTH_TEXTAREA_EXTENDED, URL_ERROR_VALIDATION } from '../../../constants';
import { emailField, phoneField, switchField, textareaField, textField } from '../../../utils/field-config-helpers';

const baseFields = {
  address: textareaField({
    required: true,
  }),
  website: textField({
    validateOnChange: true,
    validator: ({ value }) => {
      if (!value) return '';
      if (isValidHTTPUrl(value)) return '';
      else return URL_ERROR_VALIDATION;
    },
  }),
  linkToFaqs: textField({
    validator: (props) => {
      const { value } = props;
      if (isValidHTTPUrl(value)) return '';
      else return URL_ERROR_VALIDATION;
    },
  }),
  locationTips: textareaField(),
  parkingTips: textareaField(),
  billingName: textField({
    required: true,
  }),
  billingEmail: emailField({
    required: true,
  }),
  billingPhoneNumber: phoneField({
    required: true,
  }),
  newPatients: switchField(),
  childrenAsPatients: textareaField(),
  specificProcedures: textareaField(undefined, MAX_LENGTH_TEXTAREA_EXTENDED),
  differentiation: textareaField(undefined, MAX_LENGTH_TEXTAREA_EXTENDED),
  comforting: textareaField(),
} satisfies FormConfig;

// Combine base fields with availability hours fields
export const businessProfileFields = {
  ...baseFields,
  ...getAvailabilityHoursFormFields(),
} satisfies FormConfig;

// Explicitly type to include both base fields and availability hours fields
export type BusinessProfileFieldTypes = typeof baseFields & AvailabilityHoursFormConfig;
